import { useInfiniteTableScroll } from "hooks/useInfiniteTableScroll";

import { DataTable } from "./DataTable";
import type { DataTableVirtualizedProps } from "./types";

export const DataTableVirtualized = <TData,>({
  onFetchMore,
  virtualizerOptions,
  ...tableProps
}: DataTableVirtualizedProps<TData>) => {
  const { scrollRef, virtualizer } = useInfiniteTableScroll(onFetchMore, {
    count: tableProps.tableOptions.data.length,
    ...virtualizerOptions,
  });

  return (
    <DataTable<TData>
      ref={scrollRef}
      height={`calc(min(${virtualizer.getTotalSize()}px, 100%))`}
      {...tableProps}
    />
  );
};

export default DataTableVirtualized;
